<template>
	<v-snackbar :timeout="0" v-model="value" top>
		{{ text }}
		<v-progress-circular size="25" indeterminate color="primary"></v-progress-circular>
	</v-snackbar>
</template>

<script>
	export default {
		props: ["value", "text"],
		methods: {
			close() {
				this.$emit("input", !this.value);
			}
		}
	};
</script>

<style>
</style>
